import { traerTodosLoSalones, traerTodosLosCalendarios, traerTodosEventos, MoverEvento, obtener_EventoEspesifico, extaereporteApi } from "./Api_Calendario_Providers";

/**
 * Obtiene la lista de calendarios desde la API.
 *
 * @returns {Function} Función asíncrona que retorna una promesa con la lista de calendarios.
 */
export const obtenerListaCalendarios = () => {
    return async () => {
        try {
            // Llama a la API para obtener la lista de calendarios.
            const resultado = await traerTodosLosCalendarios();

            // Retorna los datos del primer resultado de la respuesta.
            return resultado.data["0"];
        } catch (error) {
            // Captura y registra cualquier error ocurrido durante la solicitud.
            console.error("Error al obtener la lista de calendarios:", error);
        }
    };
};

/**
 * Obtiene la lista de salones desde la API filtrada por ID de salón.
 *
 * @param {number} SalonesId - ID del salón para filtrar los resultados.
 * @returns {Function} Función asíncrona que retorna una promesa con la lista de salones.
 */
export const obtenerListaSalones = (SalonesId) => {
    return async () => {
        try {
            // Llama a la API para obtener la lista de salones utilizando el ID proporcionado.
            const resultado = await traerTodosLoSalones({ SalonesId });

            // Retorna los datos del primer resultado de la respuesta.
            return resultado.data["0"];
        } catch (error) {
            // Captura y registra cualquier error ocurrido durante la solicitud.
            console.error("Error al obtener la lista de salones:", error);
        }
    };
};

/**
 * Obtiene la lista de eventos desde la API filtrada por ID de salón y rango de fechas.
 *
 * @param {number} SalonesId - ID del salón para filtrar los eventos.
 * @param {string} startValue - Fecha de inicio para filtrar los eventos (formato 'YYYY-MM-DD').
 * @param {string} endValue - Fecha de fin para filtrar los eventos (formato 'YYYY-MM-DD').
 * @returns {Function} Función asíncrona que retorna una promesa con la lista de eventos.
 */
export const obtenerListaEventos = (SalonesId, startValue, endValue) => {
    return async () => {
        try {
            // Llama a la API para obtener la lista de eventos con los parámetros proporcionados.
            const resultado = await traerTodosEventos({ SalonesId, startValue, endValue });

            // Retorna los datos del primer resultado de la respuesta.
            return resultado.data["0"];
        } catch (error) {
            // Captura y registra cualquier error ocurrido durante la solicitud.
            console.error("Error al obtener la lista de eventos:", error);
        }
    };
};



/**
 * Modifica las fechas de inicio y fin de un evento en el sistema.
 *
 * @param {number} id - ID del evento a mover.
 * @param {string} eventStart - Nueva fecha y hora de inicio del evento (formato 'YYYY-MM-DD HH:mm:ss').
 * @param {string} eventEnd - Nueva fecha y hora de finalización del evento (formato 'YYYY-MM-DD HH:mm:ss').
 * @returns {Function} Función thunk que retorna una promesa con los datos actualizados del evento.
 */
export const ModificarMoverEvento = (id, eventStart, eventEnd, id_salon) => {

    return async () => {
        try {
            // Llama a la función MoverEvento para procesar la solicitud a la API.
            const resultado = await MoverEvento({ id, eventStart, eventEnd, id_salon });

            // Retorna los datos del primer resultado de la respuesta.
            return resultado.data["0"];
        } catch (error) {
            // Captura y registra cualquier error ocurrido durante la solicitud.
            console.error("Error al modificar las fechas del evento:", error);

            // Opcional: puedes lanzar el error para manejo adicional en el controlador.
            throw new Error("Error al mover el evento.");
        }
    };
};




 
/**
 * Acción para obtener los datos de un evento específico desde el backend utilizando su ID.
 *
 * @param {number} id - Identificador único del evento a buscar.
 * @returns {Function} Función thunk que realiza la solicitud y retorna una promesa con los datos del evento.
 * @throws {Error} Lanza un error si la solicitud falla o si no se encuentran datos.
 */
export const obtenerEventoEspesifico = (id) => {
    return async () => {
        try {
            // Llama a la función `obtener_EventoEspesifico` para realizar la solicitud a la API.
            const resultado = await obtener_EventoEspesifico({ id });

            // Devuelve los datos del primer resultado obtenido de la API.
            return resultado.data;
        } catch (error) {
            // Maneja y registra cualquier error que ocurra durante la solicitud.
            console.error("Error al obtener los datos del evento específico:", error);

            // Lanza un error con un mensaje amigable para su manejo en niveles superiores.
            throw new Error("Error al obtener los datos del evento específico.");
        }
    };
};


export const reporteDeeventos = (startValue, endValue) => {
    return async () => {
        try {
            // Llama a la API para obtener el reporte de eventos usando los parámetros proporcionados.
            const resultado = await extaereporteApi({ startValue, endValue });

            // Devuelve los datos contenidos en la primera capa de la respuesta.
            return resultado.data.data;
        } catch (error) {
            // Registra cualquier error ocurrido durante la ejecución de la solicitud.
            console.error("Error al obtener el reporte de eventos:", error);
        }
    };
};
